import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeepLink } from '../../hooks/useDeepLink';
import { setGlobalNavigate } from '../../services/navigationRef';

/**
 * DeepLinkHandler — Mounts the useDeepLink hook inside the Router context.
 * Must be placed inside <Router> to have access to useNavigate.
 * Also registers the global navigate reference for OneSignal click handlers.
 * Renders nothing — side-effect only.
 */
export function DeepLinkHandler() {
  const navigate = useNavigate();

  // Register global navigate so OneSignal notification clicks can navigate
  // even though they run outside the React tree (MemoryRouter-compatible).
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  useDeepLink();
  return null;
}
